
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $0f15715cbfbe7ebf$exports = {};
$0f15715cbfbe7ebf$exports = "precision highp float;\n#define GLSLIFY 1\n\nuniform float uTime;\nuniform float uSize;\n\nvoid main() {\n  float x = gl_FragCoord.x;\n  float y = gl_FragCoord.y;\n  float nx = x / uSize + 0.5;\n  float ny = y / uSize + 0.5;\n\n  // float time = uTime;\n  float st = uTime / 5.0;\n\n  float c = sin(((ny * ny - sin(st * 0.1)) * (nx / ny - 0.2 * cos(st * 0.05)) * 0.85 + st * 0.2) * 30.0);\n\n  gl_FragColor = vec4(c * 0.5, 0.0, c * (1.0 + sin(st)) * 0.2, 1.0);\n}\n";


var $dc658b87bc6d7097$exports = {};
$dc658b87bc6d7097$exports = "precision highp float;\n#define GLSLIFY 1\n\nuniform float uTime;\n\nvoid main() {\n  float x = gl_FragCoord.x;\n  float y = gl_FragCoord.y;\n  float time = uTime;\n  float tek = mod((y / 2.0 + sin((x) / 6.0)) + cos(y / 20.0) * 3.0 + cos(x / 20.0 + time / 20.0) * 1.4 - time / 2.0, 35.0) / 15.0;\n  gl_FragColor = vec4(tek * 0.4, 0.1, 2.0 - tek * 0.5, 1.0);\n}\n";


var $2873a52efb3d4c73$exports = {};
$2873a52efb3d4c73$exports = "precision highp float;\n#define GLSLIFY 1\n\nuniform float uTime;\nuniform float uSize;\n\nvoid main() {\n  vec2 pos = gl_FragCoord.xy / uSize;\n  float x = pos.x;\n  float y = pos.y;\n  float t = uTime / 15.0;\n\n  float faq = uSize / 3.5;\n\n  float circles1 = sin(sin(t + 0.0) * 1.0 + x * faq) + cos(cos(t + 0.0) * 1.0 + y * faq);\n  float circles2 = sin(sin(t + 3.1) * 4.0 + x * faq) + cos(cos(t + 3.14) * 4.0 + y * faq);\n  float circles3 = sin(sin(t + 0.0) * 4.0 + x * faq) + cos(cos(t + 0.0) * 4.0 + y * faq);\n\n  gl_FragColor = vec4(circles1, circles2, circles3, 1.0);\n}\n";


var $ef007bd40edb12e4$exports = {};
$ef007bd40edb12e4$exports = "precision highp float;\n#define GLSLIFY 1\n\nuniform float uTime;\nuniform float uSize;\n\nvoid main() {\n\n  float x = gl_FragCoord.x;\n  float y = gl_FragCoord.y;\n\n  float nx = x / uSize;\n  float ny = y / uSize;\n\n  float time = -uTime;\n  float tek = mod((y / 2.0 + sin((x) / 6.0)) + cos(y / 20.0) * 3.0 + cos(x / 20.0 + time / 20.0) * 1.4 - time / 2.0, 35.0) / 15.0;\n\n  // base blue color\n  vec3 blue = vec3(0.5, 0.7, 0.9);\n  vec3 white = vec3(1.0, 1.0, 1.0);\n  vec3 yellow = vec3(1.0, 0.8, 0.5);\n  \n  float bgMask = clamp((sin(x/30.0) + cos(0.7 + y / 70.0) * 12.0 + 1.0) / .8, 0.0, 1.0);\n  float bgMask2 = clamp((sin(x/30.0) * 0.8 + cos(0.8 + y / 75.0) * 12.0 + 0.2) / .8, 0.0, 1.0);\n  vec3 beach = ((1.0 + sin(ny * 8.3 * nx * 2.2) / 5.0) * yellow * bgMask) + (blue * (1.0 - bgMask));\n\n  float bigWave = 1.0 - min(1.0, mod((y / 2.0 + sin((x) / 8.0)) + cos(y / 13.0) * (1.0 - ny) * 5.0 + cos(x / 20.0 + time / 20.0) * 1.4 - time / 1.0, 42.0) / 30.0);\n\n  gl_FragColor = vec4(white * bigWave * (1.0 - bgMask2) * 0.6 + beach * 0.9, 1.0);\n\n  // gl_FragColor = vec4(white * bigWave, 1.0);\n\n}\n";


var $a060a583851ca8f0$exports = {};
$a060a583851ca8f0$exports = "precision highp float;\n#define GLSLIFY 1\n\nuniform float uTime;\nuniform float uSize;\n\nvoid main() {\n  vec2 pos = gl_FragCoord.xy / uSize;\n  \n  float t = uTime / 5.0;\n\n  float circleCount = 7.0;\n  float radius = 0.4;\n\n  vec2 uv = fract(pos * circleCount);\n\n  float speed = 0.2 + pos.x / 3.0;\n  float dist = length(uv - vec2(0.5, 0.5) + vec2(sin(t*speed), cos(t*speed)) * 0.3);\n  float color = smoothstep(radius + 0.01, radius - 0.01, dist);\n\n  float speed2 = 0.6 + pos.y / 2.2;\n  float dist2 = length(uv - vec2(0.5, 0.5) + vec2(sin(t*speed2), cos(t*speed2)) * 0.3);\n  float green = smoothstep(radius + 0.01, radius - 0.01, dist2);\n\n  float speed3 = 1.0 + pos.x / 2.5;\n  float dist3 = length(uv - vec2(0.5, 0.5) + vec2(sin(t*speed3), cos(t*speed3)) * 0.3);\n  float blue = smoothstep(radius + 0.01, radius - 0.01, dist3);\n\n  gl_FragColor = vec4(0.2 + color, 0.1+ green, 0.4+blue, 1.0);\n}\n";


// List of all the fragment shaders
const $a07aa2f7429f37c8$var$shaders = [
    (0, (/*@__PURE__*/$parcel$interopDefault($2873a52efb3d4c73$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($0f15715cbfbe7ebf$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($dc658b87bc6d7097$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($ef007bd40edb12e4$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($a060a583851ca8f0$exports)))
];
// Pick a random shader
let $a07aa2f7429f37c8$var$shaderIndex = Math.floor(Math.random() * $a07aa2f7429f37c8$var$shaders.length);
// Just a fullscreen square
const $a07aa2f7429f37c8$var$vertices = new Float32Array([
    -1,
    -1,
    1,
    1,
    -1,
    1,
    -1,
    -1,
    1,
    -1,
    1,
    1
]);
// Simple vertex shader for the 2d square that will be fullscreen
const $a07aa2f7429f37c8$var$vertex = `
attribute vec2 aVertexPosition;

void main() {
gl_Position = vec4(aVertexPosition, 0.0, 1.0);
}
`;
// Setup canvas
const $a07aa2f7429f37c8$var$canvasSize = 256;
const $a07aa2f7429f37c8$var$canvas1 = document.getElementById("canvas1");
const $a07aa2f7429f37c8$var$gl1 = $a07aa2f7429f37c8$var$canvas1.getContext("webgl");
$a07aa2f7429f37c8$var$canvas1.width = $a07aa2f7429f37c8$var$canvasSize;
$a07aa2f7429f37c8$var$canvas1.height = $a07aa2f7429f37c8$var$canvasSize;
// Canvas 2
const $a07aa2f7429f37c8$var$canvas2 = document.getElementById("canvas2");
const $a07aa2f7429f37c8$var$gl2 = $a07aa2f7429f37c8$var$canvas2.getContext("webgl");
$a07aa2f7429f37c8$var$canvas2.width = $a07aa2f7429f37c8$var$canvasSize;
$a07aa2f7429f37c8$var$canvas2.height = $a07aa2f7429f37c8$var$canvasSize;
function $a07aa2f7429f37c8$var$createProgram(gl, fragmentShader) {
    // Reset view
    gl.viewport(0, 0, $a07aa2f7429f37c8$var$canvasSize, $a07aa2f7429f37c8$var$canvasSize);
    gl.clearColor(0, 0, 0, 1);
    gl.clear(gl.COLOR_BUFFER_BIT);
    // Vertex shader stuff
    const vs = gl.createShader(gl.VERTEX_SHADER);
    gl.shaderSource(vs, $a07aa2f7429f37c8$var$vertex);
    gl.compileShader(vs);
    // Fragment shader stuff
    const fs = gl.createShader(gl.FRAGMENT_SHADER);
    gl.shaderSource(fs, fragmentShader);
    gl.compileShader(fs);
    const program = gl.createProgram();
    gl.attachShader(program, vs);
    gl.attachShader(program, fs);
    gl.linkProgram(program);
    // Pass our glorious square into a buffer
    const vbuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, vbuffer);
    gl.bufferData(gl.ARRAY_BUFFER, $a07aa2f7429f37c8$var$vertices, gl.STATIC_DRAW);
    // Load the programm
    gl.useProgram(program);
    // Show errors if any
    if (!gl.getShaderParameter(vs, gl.COMPILE_STATUS)) console.log(gl.getShaderInfoLog(vs));
    if (!gl.getShaderParameter(fs, gl.COMPILE_STATUS)) console.log(gl.getShaderInfoLog(fs));
    if (!gl.getProgramParameter(program, gl.LINK_STATUS)) console.log(gl.getProgramInfoLog(program));
    // Init time uniform
    program.uTime = gl.getUniformLocation(program, "uTime");
    gl.uniform1f(program.uTime, 1.0);
    // size uniform
    program.uSize = gl.getUniformLocation(program, "uSize");
    gl.uniform1f(program.uSize, $a07aa2f7429f37c8$var$canvasSize);
    // eh?
    program.aVertexPosition = gl.getAttribLocation(program, "aVertexPosition");
    gl.enableVertexAttribArray(program.aVertexPosition);
    gl.vertexAttribPointer(program.aVertexPosition, 2, gl.FLOAT, false, 0, 0);
    return (timestamp)=>{
        // Load the programm
        gl.useProgram(program);
        gl.uniform1f(program.uTime, timestamp / 80);
        gl.drawArrays(gl.TRIANGLES, 0, 6);
    };
}
const $a07aa2f7429f37c8$var$state = {
    gl: $a07aa2f7429f37c8$var$gl1,
    render: $a07aa2f7429f37c8$var$createProgram($a07aa2f7429f37c8$var$gl1, $a07aa2f7429f37c8$var$shaders[$a07aa2f7429f37c8$var$shaderIndex])
};
const $a07aa2f7429f37c8$var$loop = (timestamp)=>{
    $a07aa2f7429f37c8$var$state.render(timestamp);
    requestAnimationFrame($a07aa2f7429f37c8$var$loop);
};
$a07aa2f7429f37c8$var$loop();
const $a07aa2f7429f37c8$var$onClick = ()=>{
    $a07aa2f7429f37c8$var$shaderIndex = ($a07aa2f7429f37c8$var$shaderIndex + 1) % $a07aa2f7429f37c8$var$shaders.length;
    const newGl = $a07aa2f7429f37c8$var$state.gl === $a07aa2f7429f37c8$var$gl1 ? $a07aa2f7429f37c8$var$gl2 : $a07aa2f7429f37c8$var$gl1;
    const currentCanvas = $a07aa2f7429f37c8$var$state.gl === $a07aa2f7429f37c8$var$gl1 ? $a07aa2f7429f37c8$var$canvas1 : $a07aa2f7429f37c8$var$canvas2;
    const newCanvas = $a07aa2f7429f37c8$var$state.gl === $a07aa2f7429f37c8$var$gl1 ? $a07aa2f7429f37c8$var$canvas2 : $a07aa2f7429f37c8$var$canvas1;
    $a07aa2f7429f37c8$var$createProgram(newGl, $a07aa2f7429f37c8$var$shaders[$a07aa2f7429f37c8$var$shaderIndex]);
    $a07aa2f7429f37c8$var$state.render = $a07aa2f7429f37c8$var$createProgram(newGl, $a07aa2f7429f37c8$var$shaders[$a07aa2f7429f37c8$var$shaderIndex]);
    $a07aa2f7429f37c8$var$state.gl = newGl;
    newCanvas.style.transform = `translateX(128px)`;
    currentCanvas.style.transform = `translateX(-128px)`;
    setTimeout(()=>{
        currentCanvas.style.boxShadow = 'none';
        currentCanvas.style.zIndex = 0;
        currentCanvas.style.transform = `translateX(0px)`;
        newCanvas.style.transform = `translateX(0px)`;
        newCanvas.style.zIndex = 1;
        newCanvas.style.boxShadow = null;
    }, 200);
};
const $a07aa2f7429f37c8$var$stage = document.getElementById("stage");
$a07aa2f7429f37c8$var$stage.onclick = $a07aa2f7429f37c8$var$onClick;






//# sourceMappingURL=dubenko.dev.e27038b5.js.map
